/**
 * Compensation plan API
 */

import api from "../../../shared/api.jsx";

const endpoints = {
  list: (jobId) => `/orders/${jobId}/compensation-plans`,
  byId: (jobId, planId) => `/orders/${jobId}/compensation-plans/${planId}`,
  previewEmail: (jobId, planId, sequence) =>
    `/orders/${jobId}/compensation-plans/${planId}/installments/${sequence}/preview-email`,
  previewProviderFyi: (jobId, planId, sequence) =>
    `/orders/${jobId}/compensation-plans/${planId}/installments/${sequence}/preview-provider-fyi`,
  payInstallment: (jobId, planId, sequence) =>
    `/orders/${jobId}/compensation-plans/${planId}/installments/${sequence}/pay`,
  due: (asOf) => {
    const q = asOf ? `?asOf=${encodeURIComponent(asOf)}` : "";
    return `/compensation-plans/due${q}`;
  },
};

export const fetchCompensationPlansByJobId = async (jobId) => {
  const response = await api.get(endpoints.list(jobId));
  return { success: response.success !== false, data: response.data || [], error: response.error };
};

export const createCompensationPlan = async (jobId, body) => {
  const response = await api.post(endpoints.list(jobId), body);
  return response;
};

export const previewInstallmentEmail = async (jobId, planId, sequence, params = {}) => {
  const q = params.reference ? `?reference=${encodeURIComponent(params.reference)}` : "";
  const response = await api.get(`${endpoints.previewEmail(jobId, planId, sequence)}${q}`);
  return { success: response.success !== false, data: response.data, error: response.error };
};

export const previewProviderFyiEmail = async (jobId, planId, sequence, params = {}) => {
  const q = params.reference ? `?reference=${encodeURIComponent(params.reference)}` : "";
  const response = await api.get(
    `${endpoints.previewProviderFyi(jobId, planId, sequence)}${q}`
  );
  return { success: response.success !== false, data: response.data, error: response.error };
};

export const payInstallment = async (jobId, planId, sequence, formData) => {
  const response = await api.post(
    endpoints.payInstallment(jobId, planId, sequence),
    formData
  );
  return response;
};

export const fetchDueInstallments = async (asOf) => {
  const response = await api.get(endpoints.due(asOf));
  return { success: response.success !== false, data: response.data || [], error: response.error };
};
